import styled from "styled-components"

const Label = styled.div`
  font-size: ${(props) => props.fontSize}px;
  text-transform: ${(props) => props.transform};
  color: ${(props) => (props.color ? props.color : null)};
`

export default Label
